import React, { useState, useRef, useEffect } from 'react'
import c from 'classnames'
import _debounce from 'lodash/debounce'
import { DownloadOutlined, FolderOutlined, SettingOutlined } from '@ant-design/icons'

import { teamSettingsUrl, exportDataUrl, teamFilesUrl, teamMetricsUrl } from '@/utils/url'
import { Input } from '@/components/common/inputs'
import { useGlobalContext } from '@/components/context'
import SimpleIconButton from '@/components/common/simple-icon-button'
import style from './icon-row.module.sass'
import commonStyle from '../common.module.sass'
import QrCode from './qr-code'


type Props = {
	setSearch: (s: string) => void
	search: string
}


const SearchFilter = (props: Props) => {
	const globalContext = useGlobalContext()
	const inputRef = useRef<HTMLInputElement>(null)
	const [innerSearch, setInnerSearch] = useState("")
	const debouncedOuterSearch = useRef(_debounce(props.setSearch, 230))
	const setSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setInnerSearch(e.target.value)
		debouncedOuterSearch.current(e.target.value)
	}

	useEffect(() => {
		props.setSearch("")
	}, [globalContext.currentModule, globalContext.currentTeam])

	return (
		<div>
			<div className={style.iconRow}>
				{ globalContext.organisation.csvDownloadEnabled &&
					<SimpleIconButton
						to={exportDataUrl(globalContext)}
						antIcon={<DownloadOutlined style={{ fontSize: '1.6rem' }} />}
						title="Download csv"
					/>
				}
				{ globalContext.currentTeam && globalContext.organisation.showTeamFiles && 
					<SimpleIconButton
						to={teamFilesUrl(globalContext)}
						antIcon={<FolderOutlined style={{ fontSize: '1.6rem' }} />}
						title="Files"
					/>
				}
				{ globalContext.currentTeam && globalContext.user.topLevelManager &&
					<SimpleIconButton
						to={teamSettingsUrl(globalContext)}
						antIcon={<SettingOutlined style={{ fontSize: '1.6rem' }} />}
						title="Settings"
					/>
				}
				{ globalContext.currentModule.publicRecordCreateLinks.length > 0 &&
					<QrCode />
				}
			</div>
			<div className={style.searchInputContainer}>
				<Input
					className={style.searchInput}
					placeholder="Search..."
					ref={inputRef}
					onChange={setSearch}
					value={innerSearch}
				/>
			</div>
				
			<div className={commonStyle.lineSpacer} />
		</div>
	)
}

export default SearchFilter